import axiosInstance from '../utils/axios';

export const networkGetToken = async (data) => {
  const res = await axiosInstance.post('authentication/login', { ...data, appid: 9999 });
  return res;
};

export const networkVerifyToken = async (token) => {
  const res = await axiosInstance.post(`Authentication/Verify/`);
  return res;
};
